export const labels_hr = {
  applicationNameLong: "SelfCare",
  applicationNameShort: "SC",
  username: "Korisničko ime",
  usernamePlaceholder: "Unesite korisničko ime",
  password: "Lozinka",
  passwordPlaceholder: "Unesite lozinku",
  confirmPassword: "Potvrdite lozniku",
  login: "Prijava",
  needAccount: "Trebaš račun?",
  register: "Registriraj se",
  registration: "Registracija",
  logout: "Odjava",
  home: "Početna",
  all: "Svi",
  search: "Pretraga",
  name: "Naziv",
  namePlaceholder: "Unesite naziv",
  uriPlaceholder: "Unesite URI",
  institutionPlaceholder: "Unesite ustanovu",
  id: "ID",
  description: "Opis",
  descriptionPlaceholder: "Unesite opis",
  closeButton: "Zatvori",
  saveButton: "Spremi",
  comments: "Komentari",
  commentBox: "Napiši poruku...",
  comment: "Komentiraj",
  fullName: "Ime i prezime",
  previous: "Prethodno",
  next: "Slijedeće",
  submit: "Potvrdi",
  cancel: "Odustani",
  pageNotFound: "Stranica nije pronađena",
  welcome: "DEP - SelfCare - Dobrodošli",
  administration: "Administracija",
  knowledgeManagement: "Baza znanja",
  classification: "Klasifikacija",
  adminClassification: "Administracija klasifikacije",
  classificationType: "Tip klasifikacije",
  classificationStatus: "Status klasifikacije",
  addButton: " Dodaj",
  deleteButton: " Obriši",
  deleteButtonDescription: "Obriši označene retke",
  code: "Kod",
  codePlaceholder: "Unesite kod",
  dateFrom: "Datum od",
  dateFromPlaceholder: "Unesite datum od",
  dateFromTo: "Datum (od-do)",
  dateTo: "Datum do",
  dateToPlaceholder: "Unesite datum do",
  statusPlaceholder: "Odaberite status",
  typePlaceholder: "Odaberite tip",
  generalData: "Opći podaci",
  classificationModel: "Model klasifikacije",
  chooseModel: "Odaberite model",
  selectedModels: "Odabrani modeli",
  noData: "Nema podataka",
  descriptionUsage: "Opis upotrebe",
  saved: "Spremljeno",
  deleted: "Obrisano",
  knowledgeType: "Vrsta znanja",
  knowledgeCopyright: "Copyright",
  knowledgeItem: "Jedinica znanja",
  knowledgeSource: "Izvor znanja",
  lifeCycle: "Životni ciklus",
  lifeCycles: "Životni ciklusi",
  lifeCycleStateType: "Tip stanja životnog ciklusa",
  lifeCycleChangedBy: "Postavio životni ciklus",
  changedBy: "Promijenio",
  recordedBy: "Zapisao",
  modifiedBy: "Zadnji promijenio",
  userInformation: "Korisničke informacije",
  note: "Zabilješka",
  uri: "URI",
  expand: "Proširi",
  selectedClassifications: "Odabrane klasifikacije",
  chooseClassification: "Odaberite klasifikaciju",
  additionalData: "Dodatni podatci",
  documents: "Dokumenti",
  documentsUpdate: "Ažuriranje informacija dokumenta",
  contentType: "Vrsta dokumenta",
  dateCreated: "Datum kreiranja",
  areYouSureDelete: "Jeste li sigurni da želite obrisati ovaj dokument?",
  no: "Ne",
  yes: "Da",
  actions: "Akcije",
  upload: "Upload",
  selectFiles: "Odaberite datoteke",
  selectedFilesNum: "datoteka",
  knowledge: "Znanje",
  previousLifeCycle: "Prošli životni ciklus",
  currentLifeCycle: "Trenutni životni ciklus",
  date: "Datum",
  ratings: "ocjena",
  rateNow: "Ocijeni",
  myRating: "Moja ocjena",
  institution: "Ustanova",
  messageLog: "Poruke",
  message: "Poruka",
  details: "Detalji",
  selectedKnowledgeSource: "Odabrani izvor znanja",
  messageLogType: "Vrsta poruke",
  lifeCycleClassDefinitions: "Definicije klasa životnih ciklusa",
  lifeCycleClassDefinition: "Definicija klasa životnih ciklusa",
  possibleNextStates: "Moguća sljedeća stanja",
  selectedNextStates: "Odabrana sljdeća stanja",
  lifeCycleTransitions: "Prijelazi životnog ciklusa",
  userRoles: "Korisničke role",
  roleTypes: "Vrste rola",
  partyRoleTypeDiscriminatorPlaceholder: "Odaberite diskriminator",
  roleType: "Vrsta role",
  involvementRoleTypePlaceholder: "Odaberite vrstu ovlasti",
  extensions: "Ekstenzije",
  users: "Korisnici",
  applicationUsers: "Korisnici aplikacije",
  externalUsers: "Vanjski korisnici",
  firstName: "Ime",
  lastName: "Prezime",
  email: "E-pošta",
  user: "Korisnik",
  roleTypeName: "Naziv vrste role",
  userRole: "Korisnička rola",
  roleTypePlaceholder: "Odaberite vrstu role",
  involvementRole: "Ovlast",
  involvementRoleTypes: "Vrste ovlasti",
  involvementRoleType: "Vrsta ovlasti",
  partyRoleTypeDiscriminator: "Diskriminator",
  sendMessage: "Pošalji",
  advancedSearchPlaceholder: "Unesite riječi",
  advancedSearch: " Napredna pretraga",
  correctWords: "Točne riječi",
  anyWords: "Bilo koja od tih riječi",
  nonWords: "Niti jedna od tih riječi",
  phrases: "Fraze",
  resetAdvancedSearchParams: "Poništi",
  advancedSearchDescription: "Riječi odvojiti zarezom",
  isAlreadySelected: "je već bila odabrana",
  isAdded: "je dodana",
  isRemoved: "je uklonjena",
  status: "Status",
  type: "Vrsta",
  parent: "Roditelj",
  parentPlaceholder: "Odaberite roditelja",
  active: "Aktivni",
  inactive: "Neaktivni",
  advancedSearchParamsDelete: "Obriši parametre napredne pretrage",
  classificationDetail: "Detalji klasifikacije",
  parentInvolvementRoleTypes: "Naslijeđene vrste ovlasti",
  atTime: ", u vremenu: ",
  rating: "Ocjena",
  backButton: "Natrag",
  newTab: "Otvori u novoj kartici",
  reactivateItem: "Vrati u rad",
  operations: "Operacije",
  involvementRoles: "Ovlasti",
  usersAndSecurity: "Korisnici i sigurnost",
  entities: "Entiteti",
  deleteItem: "Obriši",
  settings: "Postavke",
  language: "Jezik"
};
